import type { PropsWithChildren } from "react";

function ServiceFormUnitCalculatorWrapper({ children }: PropsWithChildren) {
	return (
		<div
			className="grid gap-x-4 items-end [&_*]:tabular-nums"
			style={{
				gridTemplateColumns: "1fr 1fr 1fr 250px 50px",
			}}
		>
			{children}
		</div>
	);
}

export { ServiceFormUnitCalculatorWrapper };
